import { render, staticRenderFns } from "./ProposalQuestionnaire.vue?vue&type=template&id=1ed73f61&scoped=true"
import script from "./ProposalQuestionnaire.vue?vue&type=script&lang=js"
export * from "./ProposalQuestionnaire.vue?vue&type=script&lang=js"
import style0 from "./ProposalQuestionnaire.vue?vue&type=style&index=0&id=1ed73f61&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ed73f61",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ed73f61')) {
      api.createRecord('1ed73f61', component.options)
    } else {
      api.reload('1ed73f61', component.options)
    }
    module.hot.accept("./ProposalQuestionnaire.vue?vue&type=template&id=1ed73f61&scoped=true", function () {
      api.rerender('1ed73f61', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/infra/bidDocumentation/components/ProposalQuestionnaire.vue"
export default component.exports